"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTerminalLines = exports.getInfoForAnswerChecking = exports.endsWithUserPrompt = exports.TERM_LINE_ENDING = void 0;

var _endsWith = _interopRequireDefault(require("lodash/endsWith"));

var _findLastIndex = _interopRequireDefault(require("lodash/findLastIndex"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _trim = _interopRequireDefault(require("lodash/trim"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TERM_LINE_ENDING = "\r\n";
/**
 *
 * Returns an array of trimmed lines.
 *
 * @param buffer {Object}
 * @returns {Array}
 */

exports.TERM_LINE_ENDING = TERM_LINE_ENDING;

const getTerminalLines = buffer => {
  const rows = buffer.active.length;
  const lines = [];

  for (let i = 0; i < rows; i += 1) {
    lines.push(buffer.active.getLine(i).translateToString().trim());
  }

  return (0, _filter.default)(lines, l => l.length);
};
/**
 *
 * Returns a string of terminal lines to send to the answer checker
 *
 * @param terminalLines {Array}
 * @returns {string}
 */


exports.getTerminalLines = getTerminalLines;

const getInfoForAnswerChecking = terminalLines => {
  // Last line is removed from the index search because it's always an empty prompt
  const index = (0, _findLastIndex.default)(terminalLines.slice(0, terminalLines.length - 1), l => (0, _includes.default)(l, "$"));

  if (index === -1) {
    return "";
  }

  let output = terminalLines.slice(index);
  output = output.join(TERM_LINE_ENDING);
  return output;
};
/**
 *
 * Returns true if the last character of the input is `$`
 *
 * @param data
 * @returns {boolean}
 */


exports.getInfoForAnswerChecking = getInfoForAnswerChecking;

const endsWithUserPrompt = data => (0, _endsWith.default)((0, _trim.default)(data), "$");

exports.endsWithUserPrompt = endsWithUserPrompt;